module.exports = __webpack_public_path__ + "img/naked_and_famous.147696ad.jpg";